import templateUrl from './eventTinyComponent.html';

export default {
  templateUrl,
  controllerAs: 'ctrl',
  controller: class {
    constructor(Authentication, Utils, sdk, $rootScope) {
      'ngInject';

      Object.assign(this, { Authentication, Utils, sdk, $rootScope });

      Utils.extendWithProps(sdk('constants'), this, [
        'LEAVE_TYPE',
        'SHIFT_TYPE',
        'NO_SHOW_TYPE',
        'SICK_CALLOUT_TYPE',
        'UNAVAILABILITY_TYPE',
      ]);
    }

    _isAdHocShift(shift) {
      return shift.openEnd && shift.dtstart.getTime() === shift.dtend.getTime();
    }

    isClockIconShown(shift) {
      // The clock icon is for shift with a scheduled start and an hidden end time on manager/admin side
      return this.Authentication.user.isManager && !this._isAdHocShift(shift) && shift.openEnd;
    }

    isNoEndTime(shift) {
      // The shifts with Starts at .. and no end time are unscheduled shifts and shifts with an hidden time on employee side
      return (
        this._isAdHocShift(shift) ||
        (shift.openEnd &&
          (!this.Authentication.user.isManager || this.$rootScope.HIDE_SCHEDULE_END_TIMES)) // this is for printing
      );
    }
  },
  bindings: {
    event: '<',
    shouldShowAcceptanceIndicator: '&',
  },
};
